import React, { useRef, useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { ASSET_URL } from '../../../../env/Configurations';
import { handleSlider } from '../../../../utils/UiBuilderUtils';
import './Portrait-Carousal-With-Background-Preview.scss';

const PortraitCarousalWithBackgroundPreview = (props) => {
  const { config } = props;
  const ref = useRef(null);
  const [additionalTransfrom, setAdditionalTransfrom] = useState(0);
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
  };
  const CustomSlider = ({ carouselState }) => {
    let value = 0;
    let carouselItemWidth = 0;
    if (ref?.current) {
      carouselItemWidth = ref?.current?.state?.itemWidth;
      const maxTranslateX = Math.round(
        carouselItemWidth * (ref?.current?.state?.totalItems - ref?.current?.state?.slidesToShow) +
          150,
      );
      value = maxTranslateX / 100;
      handleSlider(config, ref);
    }
    const { transform } = carouselState;
    return (
      <div className='custom-slider-portrait'>
        <input
          type='range'
          value={Math.round(Math.abs(transform) / value)}
          max={
            (carouselItemWidth * (carouselState.totalItems - carouselState.slidesToShow) +
              (additionalTransfrom === 150 ? 0 : 150)) /
            value
          }
          onChange={(e) => {
            if (ref?.current?.isAnimationAllowed) {
              ref.current.isAnimationAllowed = false;
            }
            const nextTransform = e.target.value * value;
            const nextSlide = Math.round(nextTransform / carouselItemWidth);
            if (e.target.value === 0 && additionalTransfrom === 150) {
              ref.current.isAnimationAllowed = true;
              setAdditionalTransfrom(0);
            }
            ref?.current?.setState({
              transform: -nextTransform,
              currentSlide: nextSlide,
            });
          }}
          className='custom-slider__input'
        />
      </div>
    );
  };

  return (
    <div className='potrait-carousal'>
      {config?.slides?.length && (
        <div>
          <div className='preview-title'>{config?.titleH2 ? config?.titleH2 : 'H2 Title'}</div>
          <div
            className='potrait-carousal-box'
            style={{
              backgroundColor: config?.backgroundColor || '#8f8f8f',
            }}
          >
            <Carousel
              ref={ref}
              arrows={false}
              responsive={responsive}
              autoPlay={true}
              infinite={true}
              customButtonGroup={<CustomSlider />}
            >
              {config.slides.map((slide, key) => (
                <>
                  {!slide?.isVideo && (
                    <div
                      className={`d-flex align-items-center justify-content-center h-100 ${
                        slide?.shadowOverlay ? 'shadowed-img' : ''
                      }`}
                      key={key}
                      style={
                        slide.imgURL
                          ? {
                              backgroundImage: 'url(' + ASSET_URL + slide.imgURL + ')',
                              backgroundSize: 'cover',
                            }
                          : {}
                      }
                    >
                      <div
                        className='slide-title'
                        style={slide.imgURL ? { color: 'white' } : { color: 'black' }}
                      >
                        {slide.titleH3 ? slide.titleH3 : 'H3 Title'}
                      </div>
                    </div>
                  )}
                  {slide?.isVideo && (
                    <div className={`${slide?.shadowOverlay ? 'shadowed-img' : ''}`} key={key}>
                      <div className='video-container'>
                        <video
                          style={{
                            width: '100%',
                            height: '105px',
                            objectFit: 'fill',
                            position: 'relative',
                            top: 0,
                            left: 0,
                          }}
                          autoPlay
                          loop={slide?.loopPlayBack}
                          preload='auto'
                          src={slide?.videoURL}
                          muted
                        />
                        <div
                          className='slide-title-2a'
                          style={slide.videoURL ? { color: 'white' } : { color: 'black' }}
                        >
                          {slide.titleH3 ? slide.titleH3 : 'H3 Title'}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ))}
              {config?.viewAll?.isActive && (
                <div className='h-100 d-flex justify-content-center align-items-center view-all-portrait-carousel'>
                  <div className='slide-title'>View All</div>
                </div>
              )}
            </Carousel>
          </div>
        </div>
      )}
    </div>
  );
};

export default PortraitCarousalWithBackgroundPreview;
